import { useEffect } from 'react';
import PropTypes from 'prop-types';

//assets
import {
  setHubspotFormIntegration,
  DisclaimerText,
} from '@/vendor/HubspotFormIntegration';

import {
  Section,
  Wrapper,
  TitleContainer,
  FormContainer,
} from './HubspotForm.styles';

const HubspotForm = ({
  children,
  portalId,
  formId,
  target = 'integration-hubspot',
  disclaimer = false,
  variant,
}) => {
  useEffect(() => {
    setHubspotFormIntegration({
      portalId,
      formId,

      target: `#${target}`,
    });
  }, [formId, portalId, target]);

  return (
    <Section id="hubspot-form">
      <Wrapper variant={variant}>
        <TitleContainer className="Title">{children}</TitleContainer>
        <FormContainer>
          <div id={target} />
          {disclaimer && <DisclaimerText />}
        </FormContainer>
      </Wrapper>
    </Section>
  );
};

HubspotForm.propTypes = {
  children: PropTypes.node,
  portalId: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  target: PropTypes.string,
};

HubspotForm.defaultProps = {
  children: null,
  target: 'integration-hubspot',
};

export default HubspotForm;
export { HubspotForm };
